/* A face, or the initials that stand in for one.
 *
 * INITIALS ARE NOT A FAILURE STATE. A brand-new enquiry has no photo and never will
 * until somebody adds one, so the badge is the honest answer rather than a broken
 * image or a grey silhouette that reads the same for everybody. The seed leaves half
 * of new leads without a photo on purpose.
 *
 * The path stored on a person is relative ("assets/people/f-12.jpg") because the same
 * build serves from the root in dev and from a sub-path in production. BASE_URL is
 * what makes that true; hard-coding a leading slash breaks the deployed copy only,
 * which is the worst place to find out. */
import { useState } from 'react';
import { fmt } from '../lib/fmt.js';

export type AvatarSize = 'sm' | 'md' | 'lg';

export function Avatar({ name, photoUrl, size = 'md' }: {
  name: string | null | undefined;
  photoUrl?: string | null;
  size?: AvatarSize;
}) {
  const [broken, setBroken] = useState(false);
  const initials = fmt.initials(name);

  if (!photoUrl || broken) {
    return <span className={'avatar ' + size} aria-hidden="true">{initials}</span>;
  }
  const src = /^(https?:|data:|\/)/.test(photoUrl)
    ? photoUrl
    : import.meta.env.BASE_URL + photoUrl;
  return (
    <img
      className={'avatar ' + size} src={src} alt=""
      loading="lazy" decoding="async"
      onError={() => setBroken(true)}
    />
  );
}
